/**
 * @description Standardized Official Country Codes as defined by BCP (internet Best Current Practices) 47 & ISO-3166, and used by IBAN
 * @source  https://www.iban.com/country-codes & https://www.iso.org/iso-3166-country-codes.html
 */
export enum ISO_CountryCode {
  // Afghanistan
  AF = 'AF',
  // Albania
  AL = 'AL',
  // Algeria
  DZ = 'DZ',
  // American Samoa
  AS = 'AS',
  // Andorra
  AD = 'AD',
  // Angola
  AO = 'AO',
  // Anguilla
  AI = 'AI',
  // Antarctica
  AQ = 'AQ',
  // Antigua and Barbuda
  AG = 'AG',
  // Argentina
  AR = 'AR',
  // Armenia
  AM = 'AM',
  // Aruba
  AW = 'AW',
  // Australia
  AU = 'AU',
  // Austria
  AT = 'AT',
  // Azerbaijan
  AZ = 'AZ',
  // Bahamas
  BS = 'BS',
  // Bahrain
  BH = 'BH',
  // Bangladesh
  BD = 'BD',
  // Barbados
  BB = 'BB',
  // Belarus
  BY = 'BY',
  // Belgium
  BE = 'BE',
  // Belize
  BZ = 'BZ',
  // Benin
  BJ = 'BJ',
  // Bermuda
  BM = 'BM',
  // Bhutan
  BT = 'BT',
  // Bolivia
  BO = 'BO',
  // Bonaire, Sint Eustatius and Saba
  BQ = 'BQ',
  // Bosnia and Herzegovina
  BA = 'BA',
  // Botswana
  BW = 'BW',
  // Bouvet Island
  BV = 'BV',
  // Brazil
  BR = 'BR',
  // British Indian Ocean Territory
  IO = 'IO',
  // Brunei Darussalam
  BN = 'BN',
  // Bulgaria
  BG = 'BG',
  // Burkina Faso
  BF = 'BF',
  // Burundi
  BI = 'BI',
  // Cabo Verde
  CV = 'CV',
  // Cambodia
  KH = 'KH',
  // Cameroon
  CM = 'CM',
  // Canada
  CA = 'CA',
  // Cayman Islands
  KY = 'KY',
  // Central African Republic
  CF = 'CF',
  // Chad
  TD = 'TD',
  // Chile
  CL = 'CL',
  // China
  CN = 'CN',
  // Christmas Island
  CX = 'CX',
  // Cocos (Keeling) Islands
  CC = 'CC',
  // Colombia
  CO = 'CO',
  // Comoros
  KM = 'KM',
  // Congo (Democratic Republic of the)
  CD = 'CD',
  // Congo
  CG = 'CG',
  // Cook Islands
  CK = 'CK',
  // Costa Rica
  CR = 'CR',
  // Croatia
  HR = 'HR',
  // Cuba
  CU = 'CU',
  // Curaçao
  CW = 'CW',
  // Cyprus
  CY = 'CY',
  // Czechia
  CZ = 'CZ',
  // Côte d'Ivoire
  CI = 'CI',
  // Denmark
  DK = 'DK',
  // Djibouti
  DJ = 'DJ',
  // Dominica
  DM = 'DM',
  // Dominican Republic
  DO = 'DO',
  // Ecuador
  EC = 'EC',
  // Egypt
  EG = 'EG',
  // El Salvador
  SV = 'SV',
  // Equatorial Guinea
  GQ = 'GQ',
  // Eritrea
  ER = 'ER',
  // Estonia
  EE = 'EE',
  // Eswatini
  SZ = 'SZ',
  // Ethiopia
  ET = 'ET',
  // Falkland Islands [Malvinas]
  FK = 'FK',
  // Faroe Islands
  FO = 'FO',
  // Fiji
  FJ = 'FJ',
  // Finland
  FI = 'FI',
  // France
  FR = 'FR',
  // French Guiana
  GF = 'GF',
  // French Polynesia
  PF = 'PF',
  // French Southern Territories
  TF = 'TF',
  // Gabon
  GA = 'GA',
  // Gambia
  GM = 'GM',
  // Georgia
  GE = 'GE',
  // Germany
  DE = 'DE',
  // Ghana
  GH = 'GH',
  // Gibraltar
  GI = 'GI',
  // Greece
  GR = 'GR',
  // Greenland
  GL = 'GL',
  // Grenada
  GD = 'GD',
  // Guadeloupe
  GP = 'GP',
  // Guam
  GU = 'GU',
  // Guatemala
  GT = 'GT',
  // Guernsey
  GG = 'GG',
  // Guinea
  GN = 'GN',
  // Guinea-Bissau
  GW = 'GW',
  // Guyana
  GY = 'GY',
  // Haiti
  HT = 'HT',
  // Heard Island and McDonald Islands
  HM = 'HM',
  // Holy See
  VA = 'VA',
  // Honduras
  HN = 'HN',
  // Hong Kong
  HK = 'HK',
  // Hungary
  HU = 'HU',
  // Iceland
  IS = 'IS',
  // India
  IN = 'IN',
  // Indonesia
  ID = 'ID',
  // Iran (Islamic Republic of)
  IR = 'IR',
  // Iraq
  IQ = 'IQ',
  // Ireland
  IE = 'IE',
  // Isle of Man
  IM = 'IM',
  // Israel
  IL = 'IL',
  // Italy
  IT = 'IT',
  // Jamaica
  JM = 'JM',
  // Japan
  JP = 'JP',
  // Jersey
  JE = 'JE',
  // Jordan
  JO = 'JO',
  // Kazakhstan
  KZ = 'KZ',
  // Kenya
  KE = 'KE',
  // Kiribati
  KI = 'KI',
  // Korea (Democratic People's Republic of)
  KP = 'KP',
  // Korea (Republic of)
  KR = 'KR',
  // Kuwait
  KW = 'KW',
  // Kyrgyzstan
  KG = 'KG',
  // Lao People's Democratic Republic
  LA = 'LA',
  // Latvia
  LV = 'LV',
  // Lebanon
  LB = 'LB',
  // Lesotho
  LS = 'LS',
  // Liberia
  LR = 'LR',
  // Libya
  LY = 'LY',
  // Liechtenstein
  LI = 'LI',
  // Lithuania
  LT = 'LT',
  // Luxembourg
  LU = 'LU',
  // Macao
  MO = 'MO',
  // Madagascar
  MG = 'MG',
  // Malawi
  MW = 'MW',
  // Malaysia
  MY = 'MY',
  // Maldives
  MV = 'MV',
  // Mali
  ML = 'ML',
  // Malta
  MT = 'MT',
  // Marshall Islands
  MH = 'MH',
  // Martinique
  MQ = 'MQ',
  // Mauritania
  MR = 'MR',
  // Mauritius
  MU = 'MU',
  // Mayotte
  YT = 'YT',
  // Mexico
  MX = 'MX',
  // Micronesia (Federated States of)
  FM = 'FM',
  // Moldova (Republic of)
  MD = 'MD',
  // Monaco
  MC = 'MC',
  // Mongolia
  MN = 'MN',
  // Montenegro
  ME = 'ME',
  // Montserrat
  MS = 'MS',
  // Morocco
  MA = 'MA',
  // Mozambique
  MZ = 'MZ',
  // Myanmar
  MM = 'MM',
  // Namibia
  NA = 'NA',
  // Nauru
  NR = 'NR',
  // Nepal
  NP = 'NP',
  // Netherlands
  NL = 'NL',
  // New Caledonia
  NC = 'NC',
  // New Zealand
  NZ = 'NZ',
  // Nicaragua
  NI = 'NI',
  // Niger
  NE = 'NE',
  // Nigeria
  NG = 'NG',
  // Niue
  NU = 'NU',
  // Norfolk Island
  NF = 'NF',
  // Northern Mariana Islands
  MP = 'MP',
  // Norway
  NO = 'NO',
  // Oman
  OM = 'OM',
  // Pakistan
  PK = 'PK',
  // Palau
  PW = 'PW',
  // Palestine, State of
  PS = 'PS',
  // Panama
  PA = 'PA',
  // Papua New Guinea
  PG = 'PG',
  // Paraguay
  PY = 'PY',
  // Peru
  PE = 'PE',
  // Philippines
  PH = 'PH',
  // Pitcairn
  PN = 'PN',
  // Poland
  PL = 'PL',
  // Portugal
  PT = 'PT',
  // Puerto Rico
  PR = 'PR',
  // Qatar
  QA = 'QA',
  // Republic of North Macedonia
  MK = 'MK',
  // Romania
  RO = 'RO',
  // Russian Federation
  RU = 'RU',
  // Rwanda
  RW = 'RW',
  // Réunion
  RE = 'RE',
  // Saint Barthélemy
  BL = 'BL',
  // Saint Helena, Ascension and Tristan da Cunha
  SH = 'SH',
  // Saint Kitts and Nevis
  KN = 'KN',
  // Saint Lucia
  LC = 'LC',
  // Saint Martin (French part)
  MF = 'MF',
  // Saint Pierre and Miquelon
  PM = 'PM',
  // Saint Vincent and the Grenadines
  VC = 'VC',
  // Samoa
  WS = 'WS',
  // San Marino
  SM = 'SM',
  // Sao Tome and Principe
  ST = 'ST',
  // Saudi Arabia
  SA = 'SA',
  // Senegal
  SN = 'SN',
  // Serbia
  RS = 'RS',
  // Seychelles
  SC = 'SC',
  // Sierra Leone
  SL = 'SL',
  // Singapore
  SG = 'SG',
  // Sint Maarten (Dutch part)
  SX = 'SX',
  // Slovakia
  SK = 'SK',
  // Slovenia
  SI = 'SI',
  // Solomon Islands
  SB = 'SB',
  // Somalia
  SO = 'SO',
  // South Africa
  ZA = 'ZA',
  // South Georgia and the South Sandwich Islands
  GS = 'GS',
  // South Sudan
  SS = 'SS',
  // Spain
  ES = 'ES',
  // Sri Lanka
  LK = 'LK',
  // Sudan
  SD = 'SD',
  // Suriname
  SR = 'SR',
  // Svalbard and Jan Mayen
  SJ = 'SJ',
  // Sweden
  SE = 'SE',
  // Switzerland
  CH = 'CH',
  // Syrian Arab Republic
  SY = 'SY',
  // Taiwan (Province of China)
  TW = 'TW',
  // Tajikistan
  TJ = 'TJ',
  // Tanzania, United Republic of
  TZ = 'TZ',
  // Thailand
  TH = 'TH',
  // Timor-Leste
  TL = 'TL',
  // Togo
  TG = 'TG',
  // Tokelau
  TK = 'TK',
  // Tonga
  TO = 'TO',
  // Trinidad and Tobago
  TT = 'TT',
  // Tunisia
  TN = 'TN',
  // Turkey
  TR = 'TR',
  // Turkmenistan
  TM = 'TM',
  // Turks and Caicos Islands
  TC = 'TC',
  // Tuvalu
  TV = 'TV',
  // Uganda
  UG = 'UG',
  // Ukraine
  UA = 'UA',
  // United Arab Emirates
  AE = 'AE',
  // United Kingdom of Great Britain and Northern Ireland
  GB = 'GB',
  // United States Minor Outlying Islands
  UM = 'UM',
  // United States of America
  US = 'US',
  // Uruguay
  UY = 'UY',
  // Uzbekistan
  UZ = 'UZ',
  // Vanuatu
  VU = 'VU',
  // Venezuela (Bolivarian Republic of)
  VE = 'VE',
  // Viet Nam
  VN = 'VN',
  // Virgin Islands (British)
  VG = 'VG',
  // Virgin Islands (U.S.)
  VI = 'VI',
  // Wallis and Futuna
  WF = 'WF',
  // Western Sahara
  EH = 'EH',
  // Yemen
  YE = 'YE',
  // Zambia
  ZM = 'ZM',
  // Zimbabwe
  ZW = 'ZW',
  // Åland Islands
  AX = 'AX',
}

/**
 * @description Standardized Official Language Codes as defined by BCP (internet Best Current Practices) 47 & ISO639-1
 * @source https://www.iso.org/iso-639-language-code & https://iso639-3.sil.org/code_tables/639/data/all?title=&field_iso639_cd_st_mmbrshp_639_1_tid=255291&name_3=&field_iso639_element_scope_tid=All&field_iso639_language_type_tid=All&items_per_page=200
 */
export enum ISO_LanguageCode {
  // Abkhazian
  AB = 'ab',
  // Afar
  AA = 'aa',
  // Afrikaans
  AF = 'af',
  // Akan
  AK = 'ak',
  // Albanian
  SQ = 'sq',
  // Amharic
  AM = 'am',
  // Arabic
  AR = 'ar',
  // Aragonese
  AN = 'an',
  // Armenian
  HY = 'hy',
  // Assamese
  AS = 'as',
  // Avaric
  AV = 'av',
  // Avestan
  AE = 'ae',
  // Aymara
  AY = 'ay',
  // Azerbaijani
  AZ = 'az',
  // Bambara
  BM = 'bm',
  // Bashkir
  BA = 'ba',
  // Basque
  EU = 'eu',
  // Belarusian
  BE = 'be',
  // Bengali
  BN = 'bn',
  // Bihari languages
  BH = 'bh',
  // Bislama
  BI = 'bi',
  // Bosnian
  BS = 'bs',
  // Breton
  BR = 'br',
  // Bulgarian
  BG = 'bg',
  // Burmese
  MY = 'my',
  // Catalan, Valencian
  CA = 'ca',
  // Chamorro
  CH = 'ch',
  // Chechen
  CE = 'ce',
  // Chichewa, Chewa, Nyanja
  NY = 'ny',
  // Chinese
  ZH = 'zh',
  // Church Slavic, Old Slavonic, Church Slavonic, Old Bulgarian, Old Church Slavonic
  CU = 'cu',
  // Chuvash
  CV = 'cv',
  // Cornish
  KW = 'kw',
  // Corsican
  CO = 'co',
  // Cree
  CR = 'cr',
  // Croatian
  HR = 'hr',
  // Czech
  CS = 'cs',
  // Danish
  DA = 'da',
  // Divehi, Dhivehi, Maldivian
  DV = 'dv',
  // Dutch, Flemish
  NL = 'nl',
  // Dzongkha
  DZ = 'dz',
  // English
  EN = 'en',
  // Esperanto
  EO = 'eo',
  // Estonian
  ET = 'et',
  // Ewe
  EE = 'ee',
  // Faroese
  FO = 'fo',
  // Fijian
  FJ = 'fj',
  // Finnish
  FI = 'fi',
  // French
  FR = 'fr',
  // Fulah
  FF = 'ff',
  // Gaelic, Scottish Gaelic
  GD = 'gd',
  // Galician
  GL = 'gl',
  // Ganda
  LG = 'lg',
  // Georgian
  KA = 'ka',
  // German
  DE = 'de',
  // Greek, Modern (1453–)
  EL = 'el',
  // Guarani
  GN = 'gn',
  // Gujarati
  GU = 'gu',
  // Haitian, Haitian Creole
  HT = 'ht',
  // Hausa
  HA = 'ha',
  // Hebrew
  HE = 'he',
  // Herero
  HZ = 'hz',
  // Hindi
  HI = 'hi',
  // Hiri Motu
  HO = 'ho',
  // Hungarian
  HU = 'hu',
  // Icelandic
  IS = 'is',
  // Ido
  IO = 'io',
  // Igbo
  IG = 'ig',
  // Indonesian
  ID = 'id',
  // Interlingua (International Auxiliary Language Association)
  IA = 'ia',
  // Interlingue, Occidental
  IE = 'ie',
  // Inuktitut
  IU = 'iu',
  // Inupiaq
  IK = 'ik',
  // Irish
  GA = 'ga',
  // Italian
  IT = 'it',
  // Japanese
  JA = 'ja',
  // Javanese
  JV = 'jv',
  // Kalaallisut, Greenlandic
  KL = 'kl',
  // Kannada
  KN = 'kn',
  // Kanuri
  KR = 'kr',
  // Kashmiri
  KS = 'ks',
  // Kazakh
  KK = 'kk',
  // Central Khmer
  KM = 'km',
  // Kikuyu, Gikuyu
  KI = 'ki',
  // Kinyarwanda
  RW = 'rw',
  // Kirghiz, Kyrgyz
  KY = 'ky',
  // Komi
  KV = 'kv',
  // Kongo
  KG = 'kg',
  // Korean
  KO = 'ko',
  // Kuanyama, Kwanyama
  KJ = 'kj',
  // Kurdish
  KU = 'ku',
  // Lao
  LO = 'lo',
  // Latin
  LA = 'la',
  // Latvian
  LV = 'lv',
  // Limburgan, Limburger, Limburgish
  LI = 'li',
  // Lingala
  LN = 'ln',
  // Lithuanian
  LT = 'lt',
  // Luba-Katanga
  LU = 'lu',
  // Luxembourgish, Letzeburgesch
  LB = 'lb',
  // Macedonian
  MK = 'mk',
  // Malagasy
  MG = 'mg',
  // Malay
  MS = 'ms',
  // Malayalam
  ML = 'ml',
  // Maltese
  MT = 'mt',
  // Manx
  GV = 'gv',
  // Maori
  MI = 'mi',
  // Marathi
  MR = 'mr',
  // Marshallese
  MH = 'mh',
  // Mongolian
  MN = 'mn',
  // Nauru
  NA = 'na',
  // Navajo, Navaho
  NV = 'nv',
  // Ndonga
  NG = 'ng',
  // Nepali
  NE = 'ne',
  // North Ndebele
  ND = 'nd',
  // Northern Sami
  SE = 'se',
  // Norwegian
  NO = 'no',
  // Norwegian Bokmål
  NB = 'nb',
  // Norwegian Nynorsk
  NN = 'nn',
  // Nuosu, Sichuan Yi
  II = 'ii',
  // Occitan (post 1500)
  OC = 'oc',
  // Ojibwa
  OJ = 'oj',
  // Oriya
  OR = 'or',
  // Oromo
  OM = 'om',
  // Ossetian, Ossetic
  OS = 'os',
  // Pali
  PI = 'pi',
  // Panjabi, Punjabi
  PA = 'pa',
  // Pashto, Pushto
  PS = 'ps',
  // Persian
  FA = 'fa',
  // Polish
  PL = 'pl',
  // Portuguese
  PT = 'pt',
  // Quechua
  QU = 'qu',
  // Romansh
  RM = 'rm',
  // Romanian, Moldavian, Moldovan
  RO = 'ro',
  // Rundi
  RN = 'rn',
  // Russian
  RU = 'ru',
  // Samoan
  SM = 'sm',
  // Sango
  SG = 'sg',
  // Sanskrit
  SA = 'sa',
  // Sardinian
  SC = 'sc',
  // Serbian
  SR = 'sr',
  // Shona
  SN = 'sn',
  // Sindhi
  SD = 'sd',
  // Sinhala, Sinhalese
  SI = 'si',
  // Slovak
  SK = 'sk',
  // Slovenian
  SL = 'sl',
  // Somali
  SO = 'so',
  // South Ndebele
  NR = 'nr',
  // Southern Sotho
  ST = 'st',
  // Spanish, Castilian
  ES = 'es',
  // Sundanese
  SU = 'su',
  // Swahili
  SW = 'sw',
  // Swati
  SS = 'ss',
  // Swedish
  SV = 'sv',
  // Tagalog
  TL = 'tl',
  // Tahitian
  TY = 'ty',
  // Tajik
  TG = 'tg',
  // Tamil
  TA = 'ta',
  // Tatar
  TT = 'tt',
  // Telugu
  TE = 'te',
  // Thai
  TH = 'th',
  // Tibetan
  BO = 'bo',
  // Tigrinya
  TI = 'ti',
  // Tonga (Tonga Islands)
  TO = 'to',
  // Tsonga
  TS = 'ts',
  // Tswana
  TN = 'tn',
  // Turkish
  TR = 'tr',
  // Turkmen
  TK = 'tk',
  // Twi
  TW = 'tw',
  // Uighur, Uyghur
  UG = 'ug',
  // Ukrainian
  UK = 'uk',
  // Urdu
  UR = 'ur',
  // Uzbek
  UZ = 'uz',
  // Venda
  VE = 've',
  // Vietnamese
  VI = 'vi',
  // Volapük
  VO = 'vo',
  // Walloon
  WA = 'wa',
  // Welsh
  CY = 'cy',
  // Western Frisian
  FY = 'fy',
  // Wolof
  WO = 'wo',
  // Xhosa
  XH = 'xh',
  // Yiddish
  YI = 'yi',
  // Yoruba
  YO = 'yo',
  // Zhuang, Chuang
  ZA = 'za',
  // Zulu
  ZU = 'zu',
}

/**
 * @description Maps system language to native language name, with English annotation
 * @references
 *  - https://www.internationalphoneticalphabet.org/languages/language-names-in-native-language/
 *  - https://www.omniglot.com/language/names.htm
 */
export const LanguageDisplayNames = new Map([
  [ISO_LanguageCode.AB, 'аҧсуа бызшәа (Abkhazian)'],
  [ISO_LanguageCode.AA, 'Qafaraf (Afar)'],
  [ISO_LanguageCode.AF, 'Afrikaans (Afrikaans)'],
  [ISO_LanguageCode.AK, 'Akan (Akan)'],
  [ISO_LanguageCode.SQ, 'Shqip (Albanian)'],
  [ISO_LanguageCode.AM, 'አማርኛ (Amharic)'],
  [ISO_LanguageCode.AR, 'العربية (Arabic)'],
  [ISO_LanguageCode.AN, 'Aragonés (Aragonese)'],
  [ISO_LanguageCode.HY, 'Հայերեն (Armenian)'],
  [ISO_LanguageCode.AS, 'অসমীয়া (Assamese)'],
  [ISO_LanguageCode.AV, 'авар мацӀ (Avaric)'],
  [ISO_LanguageCode.AE, 'avesta (Avestan)'],
  [ISO_LanguageCode.AY, 'aymar aru (Aymara)'],
  [ISO_LanguageCode.AZ, 'azərbaycan dili (Azerbaijani)'],
  [ISO_LanguageCode.BM, 'bamanankan (Bambara)'],
  [ISO_LanguageCode.BA, 'башҡорт теле (Bashkir)'],
  [ISO_LanguageCode.EU, 'euskara (Basque)'],
  [ISO_LanguageCode.BE, 'беларуская мова (Belarusian)'],
  [ISO_LanguageCode.BN, 'বাংলা (Bengali)'],
  [ISO_LanguageCode.BH, 'भोजपुरी (Bihari languages)'],
  [ISO_LanguageCode.BI, 'Bislama (Bislama)'],
  [ISO_LanguageCode.BS, 'bosanski jezik (Bosnian)'],
  [ISO_LanguageCode.BR, 'brezhoneg (Breton)'],
  [ISO_LanguageCode.BG, 'български език (Bulgarian)'],
  [ISO_LanguageCode.MY, 'ဗမာစာ (Burmese)'],
  [ISO_LanguageCode.CA, 'català (Catalan, Valencian)'],
  [ISO_LanguageCode.CH, 'Chamoru (Chamorro)'],
  [ISO_LanguageCode.CE, 'нохчийн мотт (Chechen)'],
  [ISO_LanguageCode.NY, 'chiCheŵa (Chichewa, Chewa, Nyanja)'],
  [ISO_LanguageCode.ZH, '中文 (Chinese)'],
  [ISO_LanguageCode.CU, 'ѩзыкъ словѣньскъ (Church Slavic, Old Slavonic)'],
  [ISO_LanguageCode.CV, 'чӑваш чӗлхи (Chuvash)'],
  [ISO_LanguageCode.KW, 'kernewek (Cornish)'],
  [ISO_LanguageCode.CO, 'corsu (Corsican)'],
  [ISO_LanguageCode.CR, 'Nehiyaw (Cree)'],
  [ISO_LanguageCode.HR, 'hrvatski jezik (Croatian)'],
  [ISO_LanguageCode.CS, 'čeština (Czech)'],
  [ISO_LanguageCode.DA, 'dansk (Danish)'],
  [ISO_LanguageCode.DV, 'ދިވެހިބަސް (Divehi, Dhivehi, Maldivian)'],
  [ISO_LanguageCode.NL, 'Nederlands (Dutch, Flemish)'],
  [ISO_LanguageCode.DZ, 'རྫོང་ཁ (Dzongkha)'],
  [ISO_LanguageCode.EN, 'English (English)'],
  [ISO_LanguageCode.EO, 'Esperanto (Esperanto)'],
  [ISO_LanguageCode.ET, 'eesti (Estonian)'],
  [ISO_LanguageCode.EE, 'eʋegbe (Ewe)'],
  [ISO_LanguageCode.FO, 'føroyskt (Faroese)'],
  [ISO_LanguageCode.FJ, 'vosa Vakaviti (Fijian)'],
  [ISO_LanguageCode.FI, 'suomi (Finnish)'],
  [ISO_LanguageCode.FR, 'français (French)'],
  [ISO_LanguageCode.FF, 'Pulaar (Fulah)'],
  [ISO_LanguageCode.GD, 'Gàidhlig (Gaelic, Scottish Gaelic)'],
  [ISO_LanguageCode.GL, 'galego (Galician)'],
  [ISO_LanguageCode.LG, 'Luganda (Ganda)'],
  [ISO_LanguageCode.KA, 'ქართული (Georgian)'],
  [ISO_LanguageCode.DE, 'Deutsch (German)'],
  [ISO_LanguageCode.EL, 'Ελληνικά (Greek, Modern)'],
  [ISO_LanguageCode.GN, 'avañeʼẽ (Guarani)'],
  [ISO_LanguageCode.GU, 'ગુજરાતી (Gujarati)'],
  [ISO_LanguageCode.HT, 'Kreyòl ayisyen (Haitian, Haitian Creole)'],
  [ISO_LanguageCode.HA, 'Hausa (Hausa)'],
  [ISO_LanguageCode.HE, 'עברית (Hebrew)'],
  [ISO_LanguageCode.HZ, 'Otjiherero (Herero)'],
  [ISO_LanguageCode.HI, 'हिन्दी (Hindi)'],
  [ISO_LanguageCode.HO, 'Hiri Motu (Hiri Motu)'],
  [ISO_LanguageCode.HU, 'magyar (Hungarian)'],
  [ISO_LanguageCode.IS, 'íslenska (Icelandic)'],
  [ISO_LanguageCode.IO, 'Ido (Ido)'],
  [ISO_LanguageCode.IG, 'Asụsụ Igbo (Igbo)'],
  [ISO_LanguageCode.ID, 'Bahasa Indonesia (Indonesian)'],
  [ISO_LanguageCode.IA, 'Interlingua (Interlingua)'],
  [ISO_LanguageCode.IE, 'Interlingue (Interlingue, Occidental)'],
  [ISO_LanguageCode.IU, 'ᐃᓄᒃᑎᑐᑦ (Inuktitut)'],
  [ISO_LanguageCode.IK, 'Iñupiaq (Inupiaq)'],
  [ISO_LanguageCode.GA, 'Gaeilge (Irish)'],
  [ISO_LanguageCode.IT, 'italiano (Italian)'],
  [ISO_LanguageCode.JA, '日本語 (Japanese)'],
  [ISO_LanguageCode.JV, 'basa Jawa (Javanese)'],
  [ISO_LanguageCode.KL, 'kalaallisut (Kalaallisut, Greenlandic)'],
  [ISO_LanguageCode.KN, 'ಕನ್ನಡ (Kannada)'],
  [ISO_LanguageCode.KR, 'Kanuri (Kanuri)'],
  [ISO_LanguageCode.KS, 'کٲشُر (Kashmiri)'],
  [ISO_LanguageCode.KK, 'қазақ тілі (Kazakh)'],
  [ISO_LanguageCode.KM, 'ភាសាខ្មែរ (Central Khmer)'],
  [ISO_LanguageCode.KI, 'Gĩkũyũ (Kikuyu, Gikuyu)'],
  [ISO_LanguageCode.RW, 'Ikinyarwanda (Kinyarwanda)'],
  [ISO_LanguageCode.KY, 'Кыргызча (Kirghiz, Kyrgyz)'],
  [ISO_LanguageCode.KV, 'коми кыв (Komi)'],
  [ISO_LanguageCode.KG, 'Kikongo (Kongo)'],
  [ISO_LanguageCode.KO, '한국어 (Korean)'],
  [ISO_LanguageCode.KJ, 'Kuanyama (Kuanyama, Kwanyama)'],
  [ISO_LanguageCode.KU, 'Kurdî (Kurdish)'],
  [ISO_LanguageCode.LO, 'ພາສາລາວ (Lao)'],
  [ISO_LanguageCode.LA, 'latine (Latin)'],
  [ISO_LanguageCode.LV, 'latviešu valoda (Latvian)'],
  [ISO_LanguageCode.LI, 'Limburgs (Limburgan, Limburger, Limburgish)'],
  [ISO_LanguageCode.LN, 'Lingála (Lingala)'],
  [ISO_LanguageCode.LT, 'lietuvių kalba (Lithuanian)'],
  [ISO_LanguageCode.LU, 'Tshiluba (Luba-Katanga)'],
  [ISO_LanguageCode.LB, 'Lëtzebuergesch (Luxembourgish, Letzeburgesch)'],
  [ISO_LanguageCode.MK, 'македонски јазик (Macedonian)'],
  [ISO_LanguageCode.MG, 'fiteny malagasy (Malagasy)'],
  [ISO_LanguageCode.MS, 'Bahasa Melayu (Malay)'],
  [ISO_LanguageCode.ML, 'മലയാളം (Malayalam)'],
  [ISO_LanguageCode.MT, 'Malti (Maltese)'],
  [ISO_LanguageCode.GV, 'Gaelg (Manx)'],
  [ISO_LanguageCode.MI, 'te reo Māori (Maori)'],
  [ISO_LanguageCode.MR, 'मराठी (Marathi)'],
  [ISO_LanguageCode.MH, 'Kajin M̧ajeļ (Marshallese)'],
  [ISO_LanguageCode.MN, 'Монгол хэл (Mongolian)'],
  [ISO_LanguageCode.NA, 'Dorerin Naoero (Nauru)'],
  [ISO_LanguageCode.NV, 'Diné bizaad (Navajo, Navaho)'],
  [ISO_LanguageCode.NG, 'Owambo (Ndonga)'],
  [ISO_LanguageCode.NE, 'नेपाली (Nepali)'],
  [ISO_LanguageCode.ND, 'isiNdebele (North Ndebele)'],
  [ISO_LanguageCode.SE, 'davvisámegiella (Northern Sami)'],
  [ISO_LanguageCode.NO, 'Norsk (Norwegian)'],
  [ISO_LanguageCode.NB, 'Norsk Bokmål (Norwegian Bokmål)'],
  [ISO_LanguageCode.NN, 'Norsk Nynorsk (Norwegian Nynorsk)'],
  [ISO_LanguageCode.II, 'ꆈꌠ꒿ Nuosuhxop (Nuosu, Sichuan Yi)'],
  [ISO_LanguageCode.OC, 'occitan (Occitan, post 1500)'],
  [ISO_LanguageCode.OJ, 'ᐊᓂᔑᓈᐯᒧᐎᓐ (Ojibwa)'],
  [ISO_LanguageCode.OR, 'ଓଡ଼ିଆ (Oriya)'],
  [ISO_LanguageCode.OM, 'Afaan Oromoo (Oromo)'],
  [ISO_LanguageCode.OS, 'ирон æвзаг (Ossetian, Ossetic)'],
  [ISO_LanguageCode.PI, 'पाऴि (Pali)'],
  [ISO_LanguageCode.PA, 'ਪੰਜਾਬੀ (Panjabi, Punjabi)'],
  [ISO_LanguageCode.PS, 'پښتو (Pashto, Pushto)'],
  [ISO_LanguageCode.FA, 'فارسی (Persian)'],
  [ISO_LanguageCode.PL, 'polski (Polish)'],
  [ISO_LanguageCode.PT, 'português (Portuguese)'],
  [ISO_LanguageCode.QU, 'Runa Simi (Quechua)'],
  [ISO_LanguageCode.RM, 'rumantsch (Romansh)'],
  [ISO_LanguageCode.RO, 'română (Romanian, Moldavian, Moldovan)'],
  [ISO_LanguageCode.RN, 'Ikirundi (Rundi)'],
  [ISO_LanguageCode.RU, 'русский язык (Russian)'],
  [ISO_LanguageCode.SM, "gagana fa'a Samoa (Samoan)"],
  [ISO_LanguageCode.SG, 'yângâ tî sängö (Sango)'],
  [ISO_LanguageCode.SA, 'संस्कृतम् (Sanskrit)'],
  [ISO_LanguageCode.SC, 'sardu (Sardinian)'],
  [ISO_LanguageCode.SR, 'српски језик (Serbian)'],
  [ISO_LanguageCode.SN, 'chiShona (Shona)'],
  [ISO_LanguageCode.SD, 'سنڌي (Sindhi)'],
  [ISO_LanguageCode.SI, 'සිංහල (Sinhala, Sinhalese)'],
  [ISO_LanguageCode.SK, 'slovenčina (Slovak)'],
  [ISO_LanguageCode.SL, 'slovenski jezik (Slovenian)'],
  [ISO_LanguageCode.SO, 'Soomaaliga (Somali)'],
  [ISO_LanguageCode.NR, 'isiNdebele (South Ndebele)'],
  [ISO_LanguageCode.ST, 'Sesotho (Southern Sotho)'],
  [ISO_LanguageCode.ES, 'español (Spanish, Castilian)'],
  [ISO_LanguageCode.SU, 'Basa Sunda (Sundanese)'],
  [ISO_LanguageCode.SW, 'Kiswahili (Swahili)'],
  [ISO_LanguageCode.SS, 'siSwati (Swati)'],
  [ISO_LanguageCode.SV, 'svenska (Swedish)'],
  [ISO_LanguageCode.TL, 'Wikang Tagalog (Tagalog)'],
  [ISO_LanguageCode.TY, 'Reo Tahiti (Tahitian)'],
  [ISO_LanguageCode.TG, 'тоҷикӣ (Tajik)'],
  [ISO_LanguageCode.TA, 'தமிழ் (Tamil)'],
  [ISO_LanguageCode.TT, 'татар теле (Tatar)'],
  [ISO_LanguageCode.TE, 'తెలుగు (Telugu)'],
  [ISO_LanguageCode.TH, 'ไทย (Thai)'],
  [ISO_LanguageCode.BO, 'བོད་ཡིག (Tibetan)'],
  [ISO_LanguageCode.TI, 'ትግርኛ (Tigrinya)'],
  [ISO_LanguageCode.TO, 'lea faka-Tonga (Tonga)'],
  [ISO_LanguageCode.TS, 'Xitsonga (Tsonga)'],
  [ISO_LanguageCode.TN, 'Setswana (Tswana)'],
  [ISO_LanguageCode.TR, 'Türkçe (Turkish)'],
  [ISO_LanguageCode.TK, 'Türkmençe (Turkmen)'],
  [ISO_LanguageCode.TW, 'Twi (Twi)'],
  [ISO_LanguageCode.UG, 'ئۇيغۇرچە (Uighur, Uyghur)'],
  [ISO_LanguageCode.UK, 'українська мова (Ukrainian)'],
  [ISO_LanguageCode.UR, 'اردو (Urdu)'],
  [ISO_LanguageCode.UZ, 'oʻzbekcha (Uzbek)'],
  [ISO_LanguageCode.VE, 'Tshivenḓa (Venda)'],
  [ISO_LanguageCode.VI, 'Tiếng Việt (Vietnamese)'],
  [ISO_LanguageCode.VO, 'Volapük (Volapük)'],
  [ISO_LanguageCode.WA, 'walon (Walloon)'],
  [ISO_LanguageCode.CY, 'Cymraeg (Welsh)'],
  [ISO_LanguageCode.FY, 'Frysk (Western Frisian)'],
  [ISO_LanguageCode.WO, 'Wolof (Wolof)'],
  [ISO_LanguageCode.XH, 'isiXhosa (Xhosa)'],
  [ISO_LanguageCode.YI, 'ייִדיש (Yiddish)'],
  [ISO_LanguageCode.YO, 'Èdè Yorùbá (Yoruba)'],
  [ISO_LanguageCode.ZA, 'Saɯ cueŋƅ (Zhuang, Chuang)'],
  [ISO_LanguageCode.ZU, 'isiZulu (Zulu)'],
]);
